import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import EphemeralEnvironmentsNameTemplateImageDark from "~/areas/projects/components/EphemeralEnvironments/assets/environment-name-template-info-dark.svg";
import EphemeralEnvironmentsNameTemplateImageLight from "~/areas/projects/components/EphemeralEnvironments/assets/environment-name-template-info-light.svg";
import { useThemePaletteType } from "~/components/Theme/useThemePaletteType";
import { LearnMoreResources, OverviewContainer, OverviewHighlightText, TopicsContainer } from "../../CommonComponents/CommonViews";
const styles = {
    spacer: css({
        marginTop: space[16],
    }),
    helpImageContainer: css({
        display: "flex",
        justifyContent: "center",
    }),
};
export const ProjectEphemeralEnvironmentsHelp = () => {
    const theme = useThemePaletteType();
    const helpImage = theme === "dark" ? EphemeralEnvironmentsNameTemplateImageDark : EphemeralEnvironmentsNameTemplateImageLight;
    return (<OverviewContainer>
            <OverviewHighlightText>
                <p>
                    <ExternalLink href="EphemeralEnvironments">Ephemeral Environments</ExternalLink> allow you to automatically create test environments on-demand to gain confidence in your changes while helping to keep your infrastructures costs
                    down.
                </p>
                <div className={styles.spacer}/>
                <p>
                    Octopus will automatically create and deploy to an ephemeral environment from releases created within a specifically configured channel in a project, and supports provisioning and deprovisioning of associated infrastructure using
                    Runbooks.
                </p>
                <div className={styles.spacer}/>
                <div className={styles.helpImageContainer}>
                    <img src={helpImage} alt={"Graphic of 3 different releases. Release from branch ava/new-feature creates an environment with name ava-new-feature, a release from branch zak/new-feature creates an environment with name zak-new-feature, and a release from branch ben/new-feature creates an environment with name ben-new-feature."}/>
                </div>
            </OverviewHighlightText>
        </OverviewContainer>);
};
export const ProjectEphemeralEnvironmentsTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div>
                <ExternalLink href="OnboardingReleasesLearnMore">Releases</ExternalLink>
            </div>
            <div>
                <ExternalLink href="Channels">Channels</ExternalLink>
            </div>
            <div>
                <ExternalLink href="Runbooks">Runbooks</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
